// validateJson.js

export function validateJson(text) {
  try {
    JSON.parse(text);
    return { valid: true };
  } catch (err1) {
    try {
      const unescaped = text.replace(/\\"/g, '"');
      JSON.parse(unescaped);
      return {
        valid: true,
        message: "✅ Valid compressed JSON string",
      };
    } catch (err2) {
      const match = err2.message.match(/at position (\d+)/);
      const pos = match ? parseInt(match[1], 10) : -1;

      const getLineColumn = (text, pos) => {
        const lines = text.slice(0, pos).split("\n");
        const line = lines.length;
        const column = lines[lines.length - 1].length + 1;
        return { line, column };
      };

      const { line, column } =
        pos !== -1 ? getLineColumn(text, pos) : { line: "?", column: "?" };

      return {
        valid: false,
        message: `${err2.message} (line ${line}, column ${column})`,
      };
    }
  }
}
